import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';

import { MoreVert, ArrowUpward } from '@mui/icons-material';
import { getLanguage, useTranslation } from 'react-multi-lang';
interface iStatus   {
  "id": number,
  "order_id": number,
  "status": string,
  "status_date": string
}

export default function OrderStatusMenu({ status,statusMenu }: { status: string ,statusMenu:iStatus[]}) {
  const t = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const open = Boolean(anchorEl);
  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const options = [
    'Open',
    'Priced',
    'In Production',
    'Invoice Issued',
    'Ready',
    "Delivery Order Issued"
  ];
  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLElement>,
    index: number,
  ) => {
    setSelectedIndex(index);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <List component="nav" aria-label="Device settings">
        <ListItem
         
          id="lock-button"
          aria-haspopup="listbox"
          aria-controls="lock-menu"
          aria-label="when device is locked"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClickListItem}
          >
          <MoreVert />
        </ListItem>
      </List>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal:getLanguage()==='en'?'right': 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal:getLanguage()==='en'?'left': 'right',
        }}

        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'lock-button',
          role: 'listbox',
        }}
        sx={{
          maxHeight:'450px'
        }}
        >
        {statusMenu && statusMenu.length>0 ?
        statusMenu.map((option: iStatus, index:number) => {
          return (
            <div key={index}
            style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
              {index !== 0 && 
              <ArrowUpward />}
              <MenuItem
                key={index}
                disabled={true}
                selected={index===0}
                sx={{
                  cursor: 'auto',
                  '&.MuiList-root': {
                    '&.Mui-selected ': {
                      background: 'var(--primary-color)',
                    },
                  },
                  '&.Mui-selected ': {
                    background: 'var(--primary-color)',
                    fontWeight: 'bold',
                    color: 'white',
                    opacity: 1,
                  },
                }}>
                  <ListItemText primary={
                    <span>
                         {t(`${option.status}`)}
                    </span>
                  }  
                  secondary={
                    <span>
                         {t(`${option.status_date}`)}
                    </span>
                  }
                  >
               
                  </ListItemText>
               
              </MenuItem>
            </div>
          );
        }):
        <MenuItem>
        {getLanguage()==='en'?"Nothing to show":"لا يوجد حالات لعرضها"}
        </MenuItem>}
      </Menu>
    </div>
  );
}
